import $ from 'jquery';
import listService from 'ListService.js'
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import formatTemplate from 'properties/advanced/pages.ejs';


class PagesView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=radio]'      : 'setValue',
            'change #selectedPageSpecific'  : 'updatePageSelection'
        };
        if(!this.model.get('pageType')) {
            this.model.set('pageType','all',{silent:true});
        }
        if(!this.model.get('pageValue')) {
            this.model.set('pageValue','',{silent:true});
        }
        const list = this.model.get('pageIds') || '';
        this.model.set('selectedPageIds', list.split(','), {silent:true});

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }

    updatePageSelection() {
        let pageids = [];
        let pageidstring = '';

        $("#selectedPageSpecific :selected").each(function(){
            pageids.push( listService.cleanId($(this).val()) );
            pageidstring += ',' + listService.getCleanedId($(this).val());
        });

        if (pageidstring.length > 1) {
            pageidstring = pageidstring.substring(1);
        }

        this.model.set('selectedPageIds', pageids, {silent:true});
        this.model.set('pageIds', pageidstring, {silent: true}); // Format Used for PF Save
        this.model.trigger('change');
    }

    setValue(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );

        if(propVal === 'all') {
            //this.model.set('pageSelection', 'All');
            this.model.set('pageValue','',{silent:true});
            $('#selectedPageSpecific').attr('disabled', true);
        }
        if(propVal ==='current') {
            //this.model.set('pageSelection', 'Current');
            this.model.set('pageValue','',{silent:true});
            $('#selectedPageSpecific').attr('disabled', true);
        }
        if(propVal === 'specific') {
            //this.model.set('pageSelection','Specific');
            $('#selectedPageSpecific').attr('disabled', false);
            this.model.set('pageValue','Page 1',{silent:true});
        }

    }

    addPages(){
        let pagesList = [];
        $('#selectedPageSpecific').empty();

        listService._pageList.map(v => {
            pagesList.push(v.model.get( 'pageTitle' ));
            $('#selectedPageSpecific').append('<option value="' + v.model.get('id') + '">' + v.model.get('name') + '</option>')

        });

        _.forEach(this.model.get('selectedPageIds'), (id) => {
            $("#selectedPageSpecific option[value='"+ listService.cleanId(id) +"']").attr( "selected", true );
        });
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.addPages();

        if(this.model.get('pageType') === 'specific') {
            $('#selectedPageSpecific').attr('disabled', false);
        }

        $(":radio[value='"+this.model.get('pageType')+"']").attr('checked', true);

        this.delegateEvents();
        return this;
    }

}

export default PagesView;
